/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-param-reassign */
import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// Flare过期披露战报
export const SaadaFlareExpireDisclosureHomopage = createAsyncThunk(
  'Saada/SaadaFlare/live/hiya_socialize/flare_expire_disclosure',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/flare_expire_disclosure',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

// Flare实时表现预览 http://wiki.xunlei.cn/pages/viewpage.action?pageId=174042330
export const SaadaFlareHomopage = createAsyncThunk(
  'Saada/SaadaFlare/live/hiya_socialize/flare_rt_preview',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/flare_rt_preview',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data
  }
)

export enum FlareTypeEnum {
  中级 = 0,
  高级 = 1,
  特级 = 2,
  中级福利 = 3,
  高级福利 = 4,
}

export type SaadaFlareReport = {
  type: FlareTypeEnum
  copywriting: string
  total_viewers: number
  finish_join_users: number
  stay_5min_users: number
  value_total: number
}

const initialState: {
  home?: Partial<{
    type: FlareTypeEnum
    title: string
    desc: string
    used_seconds: number
    max_used_seconds: number
    stat: {
      total_viewers: number
      on_mic_users: number
      message_senders: number
      room_followers: number
      gift_users: number
      pearl_count: number
      bet_uv: number
      bet_coins: number
    }
    status: 0 | 1
  }>
  report?: Partial<SaadaFlareReport> | null
} = {
  home: {},
  report: null,
}

export function useSaadaFlare() {
  return useSelector((store) => store.SaadaFlare)
}

export const SaadaFlareSlice = createSlice({
  name: 'SaadaFlare',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(SaadaFlareHomopage.fulfilled, (state, action) => {
      const {data = {}} = action.payload
      Object.assign(state, {home: data})
    })
    builder.addCase(
      SaadaFlareExpireDisclosureHomopage.fulfilled,
      (state, action) => {
        const {data = null} = action.payload
        Object.assign(state, {report: data})
      }
    )
  },
})

export default SaadaFlareSlice.reducer
export const SaadaFlareActions = SaadaFlareSlice.actions
